import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useData } from "@pure-ptr/react";
import React, { useContext,useState } from 'react';

import { getClaimsSummary } from "../../store/api/summaryDashboard";
import { asDollarsWithZero } from '../../util/format';

import { DashboardFiltersContext, useStyles } from './Dashboard';
import { nonPaginatedSorting } from '../../util';
import WidgetsSortingComponent from './WidgetsSortingComponent';

export const TopClaimsWidget = () => {
    const classes = useStyles();
    const { dateRange, history } = useContext(DashboardFiltersContext);
    const [sortConfig, setSortConfig] = useState({ key: 'variance', direction: 'asc' }); 

    const { data, isPending } = useData( async () => {
        const result = await getClaimsSummary(dateRange.startdate, dateRange.enddate);
        return result;
    }, [ dateRange ]);

    const handleClaimSummaryAmountClick = (id) => {
        history.push(`/cms/claimAnalysis/view/${id}`);
    }

       const sortableColumns = [
        { key: 'variance', label: 'Variance' },
        { key: 'contractName', label: 'Contract' },
        { key: 'claimNumber', label: 'Claim Number' },
        { key: 'type', label: 'Type' },
    ];

        const sortedData = React.useMemo(
            () =>
                nonPaginatedSorting(
                    [sortConfig],
                    [...(data?.slice(0, 5) || [])]
                )?.tableData,
            [data, sortConfig]
        );
    return isPending ? (
        <CircularProgress />
    ) : (
        <Table stickyHeader>
            <TableHead>
                <TableRow key='claimsHeader'>
                    <WidgetsSortingComponent sortableColumns={sortableColumns} sortConfig={sortConfig} setSortConfig={setSortConfig}/>
                </TableRow>
            </TableHead>
            <TableBody>
                {sortedData?.map((claim) => (
                    <TableRow key={claim.claimNumber}>
                        <TableCell>
                            <Typography onClick={()=> handleClaimSummaryAmountClick(claim.id)}    
                            variant="body2" className={classes.link}>
                                {asDollarsWithZero(claim.variance)}
                            </Typography>
                        </TableCell>
                        <TableCell>{claim.contractName}</TableCell>
                        <TableCell>{claim.claimNumber}</TableCell>
                        <TableCell>{claim.type}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}